import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/home/les/work/depalop/etmflex/frontend/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/les/work/depalop/etmflex/frontend/layouts/default.vue").then(m => m.default || m)),
  nocontainer: defineAsyncComponent(() => import("/home/les/work/depalop/etmflex/frontend/layouts/nocontainer.vue").then(m => m.default || m))
}